import { useUser } from "@clerk/nextjs";
import { useQuery } from "@tanstack/react-query";

import { useTRPC } from "@/frontend/lib/trpc";

// QUERIES
export function useRemainingMonthlyMinutesQuery() {
  const { user } = useUser();
  const trpc = useTRPC();
  return useQuery({
    ...trpc.usage.getRemainingMonthlyMinutes.queryOptions(),
    enabled: !!user,
  });
}

export function useExtraMinutesQuery() {
  const { user } = useUser();
  const trpc = useTRPC();
  return useQuery({
    ...trpc.usage.getExtraMinutes.queryOptions(),
    enabled: !!user,
  });
}

export function useUsageResetDateQuery() {
  const { user } = useUser();
  const trpc = useTRPC();
  return useQuery({
    ...trpc.usage.getUsageResetDate.queryOptions(),
    enabled: !!user,
  });
}

export function useUserStats24HoursQuery() {
  const { user } = useUser();
  const trpc = useTRPC();
  return useQuery({
    ...trpc.usage.getUserStats24Hours.queryOptions(),
    refetchInterval: 60 * 1000, // 1 minute
    enabled: !!user,
  });
}
